require('./dist.less');

module.exports = require('./index');
